"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = _interopRequireDefault(require("./utils/colors"));

require("../css/strength_meter.css");

var _icon = _interopRequireDefault(require("./icon"));

var _tooltip = _interopRequireDefault(require("./tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StrengthMeter = function StrengthMeter(_ref) {
  var title = _ref.title,
      color = _ref.color,
      value = _ref.value,
      tooltipContent = _ref.tooltipContent,
      tooltipAlignment = _ref.tooltipAlignment,
      tooltipPosition = _ref.tooltipPosition,
      tooltipRole = _ref.tooltipRole,
      tooltipTabIndex = _ref.tooltipTabIndex;
  var selectedColor = _colors.default.indexOf(color) !== -1 ? color : StrengthMeter.defaultProps.color;
  var hasTooltip = tooltipContent !== '';

  var fixPercentage = function fixPercentage(percent) {
    if (percent < 0) {
      return 0;
    }

    if (percent > 100) {
      return 100;
    }

    return percent;
  };

  var percentage = fixPercentage(value);
  return _react.default.createElement("div", null, _react.default.createElement("div", {
    className: "vn-strength-meter__header"
  }, _react.default.createElement("div", {
    className: "vn-strength-meter__header__title vn-color--".concat(selectedColor)
  }, title), hasTooltip && _react.default.createElement("div", {
    className: "vn-strength-meter__header__right"
  }, _react.default.createElement(_tooltip.default, {
    alignment: tooltipAlignment,
    content: tooltipContent,
    position: tooltipPosition,
    role: tooltipRole,
    tabIndex: tooltipTabIndex
  }, _react.default.createElement(_icon.default, {
    className: "vn-strength-meter__header__right__icon",
    color: selectedColor,
    name: "warning"
  })))), _react.default.createElement("div", {
    className: "vn-strength-meter"
  }, _react.default.createElement("div", {
    className: "vn-strength-meter__bar vn-background-color--".concat(selectedColor),
    style: {
      width: "".concat(percentage, "%")
    }
  }), _react.default.createElement("div", {
    className: "vn-strength-meter__background-bar vn-background-color--neutral"
  })));
};

StrengthMeter.propTypes = {
  title: _propTypes.default.string,
  color: _propTypes.default.oneOf(_colors.default),
  value: _propTypes.default.number,
  tooltipAlignment: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left', 'middle']),
  tooltipContent: _propTypes.default.node,
  tooltipPosition: _propTypes.default.oneOf(['up', 'right', 'down', 'left']),
  tooltipRole: _propTypes.default.string,
  tooltipTabIndex: _propTypes.default.number
};
StrengthMeter.defaultProps = {
  title: '',
  color: 'foreground',
  value: 0,
  tooltipContent: '',
  tooltipAlignment: 'right',
  tooltipPosition: 'up',
  tooltipRole: undefined,
  tooltipTabIndex: undefined
};
StrengthMeter.displayName = 'StrengthMeter';
var _default = StrengthMeter;
exports.default = _default;